export class OpportunityPanelUpdate {
    exonerated: boolean;

    constructor(exonerated: boolean) {
        this.exonerated = exonerated;
    }
}
